import React from "react";

const containerStyles = {
  width: "100%",
  display: "grid",
  justifyItems: "center"
};

const styles = {
  margin: "1px",
  maxWidth: "700px"
};

export default (props: { src: any }) => (
  <div style={containerStyles}>
    <img src={props.src} alt="img" style={styles} />
  </div>
);
